const Welcome = () => import('~/pages/welcome').then(m => m.default || m)

const Evaluations = () => import('~/pages/evaluations').then(m => m.default || m)
const Reports = () => import('~/pages/reports').then(m => m.default || m)

const Login = () => import('~/pages/auth/login').then(m => m.default || m)
const Register = () => import('~/pages/auth/register').then(m => m.default || m)
const PasswordEmail = () => import('~/pages/auth/password/email').then(m => m.default || m)
const PasswordReset = () => import('~/pages/auth/password/reset').then(m => m.default || m)
const NotFound = () => import('~/pages/errors/404').then(m => m.default || m)

const Settings = () => import('~/pages/settings/index').then(m => m.default || m)
const SettingsProfile = () => import('~/pages/settings/profile').then(m => m.default || m)
const SettingsProfileIdentification = () => import('~/pages/settings/profile/identification').then(m => m.default || m)
const SettingsProfileThirdParties = () => import('~/pages/settings/profile/third_parties').then(m => m.default || m)
const SettingsProfileHealth = () => import('~/pages/settings/profile/health').then(m => m.default || m)
const SettingsProfileSkills = () => import('~/pages/settings/profile/skills').then(m => m.default || m)
const SettingsPassword = () => import('~/pages/settings/password').then(m => m.default || m)
const SettingsAccess = () => import('~/pages/settings/access').then(m => m.default || m)

const Manage = () => import('~/pages/manage/index').then(m => m.default || m)
const ManageMasks = () => import('~/pages/manage/masks').then(m => m.default || m)
const RequirementsProfiles = () => import('~/pages/manage/requirements_profiles').then(m => m.default || m)
const EditRequirementsProfiles = () => import('~/pages/manage/edit_req_profile').then(m => m.default || m)
const ManageLicense = () => import('~/pages/manage/license').then(m => m.default || m)
const ManageLicenses = () => import('~/pages/manage/licenses').then(m => m.default || m)
const ManageOrganization = () => import('~/pages/manage/organization').then(m => m.default || m)
const ManageOrganizations = () => import('~/pages/manage/organizations').then(m => m.default || m)
const ManageUsers = () => import('~/pages/manage/users').then(m => m.default || m)
const ThirdPartiesTypesTab = () => import('~/pages/manage/third_party_types_tab').then(m => m.default || m)

const ContactForm = () => import('~/pages/community/contactform').then(m => m.default || m)
const UsefulResources = () => import('~/pages/community/resources').then(m => m.default || m)

export default [
  { path: '/', name: 'welcome', component: Welcome },

  { path: '/login', name: 'login', component: Login },
  // { path: '/register', name: 'register', component: Register },
  { path: '/password/reset', name: 'password.request', component: PasswordEmail },
  { path: '/password/reset/:token', name: 'password.reset', component: PasswordReset },

  { path: '/users/:id',
    component: Settings,
    children: [
      { path: '', name: 'settings', redirect: { name: 'settings.profile' } },
      { path: 'profile', name: 'settings.profile', component: SettingsProfile },
      { path: 'password', name: 'settings.password', component: SettingsPassword },
      { path: 'access', name: 'settings.access', component: SettingsAccess }
    ]
  },

  { path: '/users/:id/evaluations', name: 'settings.evaluations', component: Evaluations },

  { path: '/manage',
    component: Manage,
    name: 'manage',
    children: [
      { path: 'license', name: 'manage.license', component: ManageLicense },
      { path: 'licenses', name: 'manage.licenses', component: ManageLicenses },
      { path: 'organization', name: 'manage.organization', component: ManageOrganization },
      { path: 'organizations', name: 'manage.organizations', component: ManageOrganizations },
      { path: 'users', name: 'manage.users', component: ManageUsers },
      { path: 'recipients', name: 'manage.recipients', component: ManageUsers },
      { path: 'thirdpartiestypes', name: 'manage.thirdpartiestypes', component: ThirdPartiesTypesTab },
      { path: 'masks', name: 'manage.masks', component: ManageMasks },
      { path: 'requirements', name: 'manage.requirements', component: RequirementsProfiles }
    ]
  },
  { path: '/manage/requirements/:id/edit', name: 'manage.requirements.edit', component: EditRequirementsProfiles },
  { path: '/community',
    component: Manage,
    name: 'community',
    children: [
      { path: 'contactform', name: 'community.contactform', component: ContactForm },
      { path: 'resources', name: 'community.resources', component: UsefulResources }
    ]
  },

  { path: '*', component: NotFound }
]



// WEBPACK FOOTER //
// ./resources/js/router/routes.js